import { getFramework, IFramework } from '@/framework';
import { BrushType, IBrushDrawConfig } from '@/version-types';
import { DRAW_EVENTS } from './event-name';
import { getBrushLayerState } from './states/brush-state';

/** 画笔绘制插件 */
export class BrushDrawPlugin {
    private framework: IFramework;

    constructor(id: string) {
        this.framework = getFramework(id);
    }

    /** 获取绘制配置 */
    getConfig() {
        return getBrushLayerState(this.framework.identity).drawConfig;
    }
    /** 打开绘制 */
    open(config: IBrushDrawConfig) {
        getBrushLayerState(this.framework.identity).setDrawConfig(config);
    }
    /** 关闭绘制 */
    close() {
        getBrushLayerState(this.framework.identity).setDrawConfig(null);
    }
    /** 监听绘制状态变化 */
    onConfigChange(fn: (drawConfig: IBrushDrawConfig | null) => void) {
        return this.framework.events.on(DRAW_EVENTS.CONFIG_CHANGE, fn);
    }
    /** 监听绘制结束 */
    onDrawEnd(fn: (brushType: BrushType) => void) {
        return this.framework.events.on(DRAW_EVENTS.DRAW_END, fn);
    }
}
